
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --outline-container--default-padding-x:1.5rem;
  --outline-container--default-padding-y:1.5rem;
}
`;